import { LucideProps } from "lucide-react";

const Icons = {
  icon: (props: LucideProps) => (
    <svg
      {...props}
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-oid="zks21q9"
    >
      <path
        d="M47.382 27.6818C46.3962 19.2469 45.357 10.3414 45.357 0H54.6419C54.6419 10.2251 53.6082 19.1198 52.6245 27.5633C51.8245 34.4449 51.0582 41.0276 50.9158 47.7886C55.5789 42.9244 59.6572 37.7678 63.929 32.3656C69.1975 25.7057 74.7606 18.6741 82.0715 11.3621L88.6379 17.9274C81.4074 25.1579 74.3867 30.7156 67.7203 35.9928L67.7138 35.9971C62.2844 40.295 57.0908 44.4059 52.2114 49.0842C58.9474 48.9418 65.4768 48.1799 72.3171 47.382C80.752 46.3972 89.6586 45.3581 100 45.3581V54.643C89.7749 54.643 80.8802 53.6082 72.4367 52.6267L72.4301 52.6256C65.5496 51.8256 58.9702 51.0603 52.2125 50.9169C57.0713 55.5756 62.2257 59.6528 67.6247 63.9224L67.6323 63.93C74.2954 69.1964 81.3281 74.7606 88.639 82.0737L82.0737 88.639C74.8432 81.4096 69.2855 74.3889 64.0105 67.7236L63.9974 67.7062L63.9866 67.692C59.6941 62.2713 55.5876 57.0854 50.9169 52.2136C51.0582 58.9735 51.8256 65.5562 52.6256 72.4377C53.6104 80.8813 54.643 89.776 54.643 100.001H45.3581C45.3581 89.6597 46.3972 80.7541 47.381 72.3193L47.3831 72.3051C48.1799 65.4703 48.9418 58.9441 49.0842 52.2136C44.4135 57.0854 40.307 62.2713 36.0134 67.692L36.0026 67.7062L35.9917 67.7225C30.7156 74.3878 25.1579 81.4096 17.9274 88.639L11.3621 82.0737C18.6741 74.7606 25.7068 69.1975 32.3667 63.93L32.3754 63.9224C37.7732 59.6528 42.9276 55.5767 47.7886 50.9169C41.0276 51.0593 34.4449 51.8256 27.5633 52.6256C19.1187 53.6082 10.224 54.643 0 54.643V45.3592C10.3414 45.3592 19.247 46.3983 27.6818 47.382C34.5221 48.181 41.0526 48.9429 47.7875 49.0853C42.907 44.4059 37.7113 40.2928 32.2797 35.9928C25.6133 30.7166 18.5915 25.159 11.3621 17.9285L17.9274 11.3632C25.2394 18.6752 30.8025 25.7068 36.07 32.3667C40.3417 37.7689 44.4211 42.9255 49.0842 47.7886C48.9418 41.0581 48.1799 34.5319 47.3831 27.697L47.381 27.6829L47.382 27.6818Z"
        fill="currentColor"
        data-oid="_:u0_.c"
      />
    </svg>
  ),

  instagram: (props: LucideProps) => (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      data-oid="g660x87"
    >
      <path
        fill="currentColor"
        d="M13.028 2c1.125.003 1.696.009 2.189.023l.194.007c.224.008.445.018.712.03c1.064.05 1.79.218 2.427.465c.66.254 1.216.598 1.772 1.153a4.9 4.9 0 0 1 1.153 1.772c.247.637.415 1.363.465 2.428c.012.266.022.487.03.712l.006.194c.015.492.021 1.063.023 2.188l.001.746v1.31a79 79 0 0 1-.023 2.188l-.006.194c-.008.225-.018.446-.03.712c-.05 1.065-.22 1.79-.466 2.428a4.9 4.9 0 0 1-1.153 1.772a4.9 4.9 0 0 1-1.772 1.153c-.637.247-1.363.415-2.427.465l-.712.03l-.194.006c-.493.014-1.064.021-2.189.023l-.746.001h-1.309a78 78 0 0 1-2.189-.023l-.194-.006a63 63 0 0 1-.712-.031c-1.064-.05-1.79-.218-2.428-.465a4.9 4.9 0 0 1-1.771-1.153a4.9 4.9 0 0 1-1.154-1.772c-.247-.637-.415-1.363-.465-2.428l-.03-.712l-.005-.194A79 79 0 0 1 2 13.028v-2.056a79 79 0 0 1 .022-2.188l.007-.194c.008-.225.018-.446.03-.712c.05-1.065.218-1.79.465-2.428A4.9 4.9 0 0 1 3.68 3.678a4.9 4.9 0 0 1 1.77-1.153c.638-.247 1.363-.415 2.428-.465c.266-.012.488-.022.712-.03l.194-.006a79 79 0 0 1 2.188-.023zM12 7a5 5 0 1 0 0 10a5 5 0 0 0 0-10m0 2a3 3 0 1 1 .001 6a3 3 0 0 1 0-6m5.25-3.5a1.25 1.25 0 0 0 0 2.5a1.25 1.25 0 0 0 0-2.5"
        data-oid="nfjr:wb"
      ></path>
    </svg>
  ),

  circle1: (props: LucideProps) => (
    <svg
      {...props}
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-oid="nzp.92r"
    >
      <path
        d="M42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21C0 9.40202 9.40202 0 21 0C32.598 0 42 9.40202 42 21ZM1.00838 21C1.00838 32.0411 9.95893 40.9916 21 40.9916C32.0411 40.9916 40.9916 32.0411 40.9916 21C40.9916 9.95893 32.0411 1.00838 21 1.00838C9.95893 1.00838 1.00838 9.95893 1.00838 21Z"
        fill="currentColor"
        data-oid="eyi0g5t"
      />
      <circle cx="21" cy="21" r="10" fill="currentColor" data-oid="-0yaowi" />
    </svg>
  ),

  circle2: (props: LucideProps) => (
    <svg
      {...props}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-oid="rikbyex"
    >
      <circle cx="10" cy="10" r="10" fill="currentColor" data-oid="5nuhdvd" />
    </svg>
  ),

  linkedin: (props: LucideProps) => (
    <svg
      {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-oid="ye88fhc"
    >
      <g clipPath="url(#clip0_17_68)" data-oid="1j1vwpd">
        <path
          d="M44.4469 0H3.54375C1.58437 0 0 1.54688 0 3.45938V44.5312C0 46.4437 1.58437 48 3.54375 48H44.4469C46.4062 48 48 46.4438 48 44.5406V3.45938C48 1.54688 46.4062 0 44.4469 0ZM14.2406 40.9031H7.11563V17.9906H14.2406V40.9031ZM10.6781 14.8688C8.39062 14.8688 6.54375 13.0219 6.54375 10.7437C6.54375 8.46562 8.39062 6.61875 10.6781 6.61875C12.9563 6.61875 14.8031 8.46562 14.8031 10.7437C14.8031 13.0125 12.9563 14.8688 10.6781 14.8688ZM40.9031 40.9031H33.7875V29.7656C33.7875 27.1125 33.7406 23.6906 30.0844 23.6906C26.3812 23.6906 25.8187 26.5875 25.8187 29.5781V40.9031H18.7125V17.9906H25.5375V21.1219H25.6312C26.5781 19.3219 28.9031 17.4188 32.3625 17.4188C39.5719 17.4188 40.9031 22.1625 40.9031 28.3313V40.9031Z"
          fill="currentColor"
          data-oid="abqlc.w"
        />
      </g>
      <defs data-oid="0qeosef">
        <clipPath id="clip0_17_68" data-oid="57mrf:6">
          <rect width="48" height="48" fill="currentColor" data-oid="8-rq27h" />
        </clipPath>
      </defs>
    </svg>
  ),

  facebook: (props: LucideProps) => (
    <svg
      {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-oid="tkk5jhc"
    >
      <g clipPath="url(#clip0_17_61)" data-oid="n979yg1">
        <path
          d="M24 0C10.7453 0 0 10.7453 0 24C0 35.255 7.74912 44.6995 18.2026 47.2934V31.3344H13.2538V24H18.2026V20.8397C18.2026 12.671 21.8995 8.8848 29.9194 8.8848C31.44 8.8848 34.0637 9.18336 35.137 9.48096V16.129C34.5706 16.0694 33.5866 16.0397 32.3645 16.0397C28.4294 16.0397 26.9088 17.5306 26.9088 21.4061V24H34.7482L33.4013 31.3344H26.9088V47.8243C38.7926 46.3891 48.001 36.2707 48.001 24C48 10.7453 37.2547 0 24 0Z"
          fill="currentColor"
          data-oid="dqss6ne"
        />
      </g>
      <defs data-oid="mplhd.t">
        <clipPath id="clip0_17_61" data-oid="jga:k12">
          <rect width="48" height="48" fill="currentColor" data-oid="czvgz1b" />
        </clipPath>
      </defs>
    </svg>
  ),

  x: (props: LucideProps) => (
    <svg
      {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-oid="6wlagjx"
    >
      <path
        d="M36.6526 3.8078H43.3995L28.6594 20.6548L46 43.5797H32.4225L21.7881 29.6759L9.61989 43.5797H2.86886L18.6349 25.56L2 3.8078H15.9222L25.5348 16.5165L36.6526 3.8078ZM34.2846 39.5414H38.0232L13.8908 7.63406H9.87892L34.2846 39.5414Z"
        fill="currentColor"
        data-oid="4p-c:_f"
      />
    </svg>
  ),

  insta: (props: LucideProps) => (
    <svg
      {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-oid="liauytf"
    >
      <g clipPath="url(#clip0_17_63)" data-oid=".gyodra">
        <path
          d="M24 4.32187C30.4125 4.32187 31.1719 4.35 33.6938 4.4625C36.0375 4.56562 37.3031 4.95938 38.1469 5.2875C39.2625 5.71875 40.0688 6.24375 40.9031 7.07812C41.7469 7.92188 42.2625 8.71875 42.6938 9.83438C43.0219 10.6781 43.4156 11.9531 43.5188 14.2875C43.6313 16.8187 43.6594 17.5781 43.6594 23.9813C43.6594 30.3938 43.6313 31.1531 43.5188 33.675C43.4156 36.0188 43.0219 37.2844 42.6938 38.1281C42.2625 39.2438 41.7375 40.05 40.9031 40.8844C40.0594 41.7281 39.2625 42.2438 38.1469 42.675C37.3031 43.0031 36.0281 43.3969 33.6938 43.5C31.1625 43.6125 30.4031 43.6406 24 43.6406C17.5875 43.6406 16.8281 43.6125 14.3063 43.5C11.9625 43.3969 10.6969 43.0031 9.85313 42.675C8.7375 42.2438 7.93125 41.7188 7.09688 40.8844C6.25313 40.0406 5.7375 39.2438 5.30625 38.1281C4.97813 37.2844 4.58438 36.0094 4.48125 33.675C4.36875 31.1438 4.34063 30.3844 4.34063 23.9813C4.34063 17.5688 4.36875 16.8094 4.48125 14.2875C4.58438 11.9437 4.97813 10.6781 5.30625 9.83438C5.7375 8.71875 6.2625 7.9125 7.09688 7.07812C7.94063 6.23438 8.7375 5.71875 9.85313 5.2875C10.6969 4.95938 11.9719 4.56562 14.3063 4.4625C16.8281 4.35 17.5875 4.32187 24 4.32187ZM24 0C17.4844 0 16.6688 0.028125 14.1094 0.140625C11.5594 0.253125 9.80625 0.665625 8.2875 1.25625C6.70312 1.875 5.3625 2.69062 4.03125 4.03125C2.69063 5.3625 1.875 6.70313 1.25625 8.27813C0.665625 9.80625 0.253125 11.55 0.140625 14.1C0.028125 16.6687 0 17.4844 0 24C0 30.5156 0.028125 31.3312 0.140625 33.8906C0.253125 36.4406 0.665625 38.1938 1.25625 39.7125C1.875 41.2969 2.69063 42.6375 4.03125 43.9688C5.3625 45.3 6.70313 46.125 8.27813 46.7344C9.80625 47.325 11.55 47.7375 14.1 47.85C16.6594 47.9625 17.475 47.9906 23.9906 47.9906C30.5063 47.9906 31.3219 47.9625 33.8813 47.85C36.4313 47.7375 38.1844 47.325 39.7031 46.7344C41.2781 46.125 42.6188 45.3 43.95 43.9688C45.2812 42.6375 46.1063 41.2969 46.7156 39.7219C47.3063 38.1938 47.7188 36.45 47.8313 33.9C47.9438 31.3406 47.9719 30.525 47.9719 24.0094C47.9719 17.4938 47.9438 16.6781 47.8313 14.1188C47.7188 11.5688 47.3063 9.81563 46.7156 8.29688C46.125 6.70312 45.3094 5.3625 43.9688 4.03125C42.6375 2.7 41.2969 1.875 39.7219 1.26562C38.1938 0.675 36.45 0.2625 33.9 0.15C31.3313 0.028125 30.5156 0 24 0Z"
          fill="currentColor"
          data-oid="m3t3epi"
        />
        <path
          d="M24 11.6719C17.1938 11.6719 11.6719 17.1938 11.6719 24C11.6719 30.8062 17.1938 36.3281 24 36.3281C30.8062 36.3281 36.3281 30.8062 36.3281 24C36.3281 17.1938 30.8062 11.6719 24 11.6719ZM24 31.9969C19.5844 31.9969 16.0031 28.4156 16.0031 24C16.0031 19.5844 19.5844 16.0031 24 16.0031C28.4156 16.0031 31.9969 19.5844 31.9969 24C31.9969 28.4156 28.4156 31.9969 24 31.9969Z"
          fill="currentColor"
          data-oid="aw.m3mc"
        />
        <path
          d="M39.6937 11.1843C39.6937 12.778 38.4 14.0624 36.8156 14.0624C35.2219 14.0624 33.9375 12.7687 33.9375 11.1843C33.9375 9.59053 35.2313 8.30615 36.8156 8.30615C38.4 8.30615 39.6937 9.5999 39.6937 11.1843Z"
          fill="currentColor"
          data-oid="-80my9v"
        />
      </g>
      <defs data-oid="hmtu.36">
        <clipPath id="clip0_17_63" data-oid="p1skuy7">
          <rect width="48" height="48" fill="currentColor" data-oid="wugbui6" />
        </clipPath>
      </defs>
    </svg>
  ),

  youtube: (props: LucideProps) => (
    <svg
      {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-oid="9yev-on"
    >
      <g clipPath="url(#clip0_17_47)" data-oid=":4.kyab">
        <path
          d="M47.044 12.3709C46.7726 11.3497 46.2378 10.4178 45.493 9.66822C44.7483 8.91869 43.8197 8.37791 42.8003 8.1C39.0476 7.09091 24.0476 7.09091 24.0476 7.09091C24.0476 7.09091 9.04761 7.09091 5.29488 8.1C4.27547 8.37791 3.34693 8.91869 2.60218 9.66822C1.85744 10.4178 1.32262 11.3497 1.05124 12.3709C0.0476075 16.14 0.0476074 24 0.0476074 24C0.0476074 24 0.0476075 31.86 1.05124 35.6291C1.32262 36.6503 1.85744 37.5822 2.60218 38.3318C3.34693 39.0813 4.27547 39.6221 5.29488 39.9C9.04761 40.9091 24.0476 40.9091 24.0476 40.9091C24.0476 40.9091 39.0476 40.9091 42.8003 39.9C43.8197 39.6221 44.7483 39.0813 45.493 38.3318C46.2378 37.5822 46.7726 36.6503 47.044 35.6291C48.0476 31.86 48.0476 24 48.0476 24C48.0476 24 48.0476 16.14 47.044 12.3709Z"
          fill="currentColor"
          data-oid="f.ze1dn"
        />
        <path
          d="M19.1385 31.1373V16.8628L31.684 24.0001L19.1385 31.1373Z"
          fill="black"
          data-oid="9r_ugmo"
        />
      </g>
      <defs data-oid="y6gom5k">
        <clipPath id="clip0_17_47" data-oid="3-f5mtf">
          <rect width="48" height="48" fill="currentColor" data-oid="7jz3.zl" />
        </clipPath>
      </defs>
    </svg>
  ),

  tiktok: (props: LucideProps) => (
    <svg
      {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-oid="t:kukp6"
    >
      <path
        d="M34.1451 0H26.0556V32.6956C26.0556 36.5913 22.9444 39.7913 19.0725 39.7913C15.2007 39.7913 12.0894 36.5913 12.0894 32.6956C12.0894 28.8696 15.1315 25.7391 18.8651 25.6V17.3913C10.6374 17.5304 4 24.2783 4 32.6956C4 41.1827 10.7757 48 19.1417 48C27.5075 48 34.2833 41.1131 34.2833 32.6956V15.9304C37.3255 18.1565 41.059 19.4783 45 19.5479V11.3391C38.9157 11.1304 34.1451 6.12173 34.1451 0Z"
        fill="currentColor"
        data-oid="pv271.b"
      />
    </svg>
  ),
};

export default Icons;
